import styled from 'styled-components'

export default styled.div`
  margin: 18px auto 0;
  width: 74.67vw;
  height: 100%;

  .slick-arrow {
    height: 20px;
    width: 10px;
    position: absolute;
    opacity: 0.3;
    z-index: 100;

    &.slick-prev {
      left: -22px;
    }
    &.slick-next {
      right: -22px;
    }
    &.slick-disabled {
      opacity: 0.1;
    }
  }

  .color-palettes-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    display: flex !important;
    flex-wrap: wrap;
    /* width: 74.67vw !important; */
    max-height: 40vh;
    margin: auto;
  }

  .color-palette-outer {
    border: 0.266vw solid #ffffff;
    margin: 0.53vw;
    /* height: 10vw; */

    &.selected {
      border: 1px solid #d7d7d7;
    }
  }

  .color-palette {
    margin: 0.8vw;
    width: 7.46vw;
    height: 7.46vw;
    &.ready {
      animation: color-swatch-ready .5s ease 0s 1 normal forwards;
    }
    &.white {
      background-image: url('data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56"><path d="M55 1v54H1V1H55M56 0H0v56h56V0L56 0z"/></svg>');
      background-size: 99%;
      background-position: top left;
      background-repeat: no-repeat;
      &.selected {
        background-image: url('data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56"><path d="M55 1v30.6L31.6 55H1V1H55M56 0H0v56h32l24-24V0L56 0z"/></svg>');
        -webkit-clip-path: none;
        clip-path: none;
      }
    }

    &.selected {
      -webkit-clip-path: polygon(100% 0, 100% 50%, 57% 100%, 0 100%, 0 0);
      clip-path: polygon(100% 0, 100% 50%, 50% 100%, 0 100%, 0 0);
    }

    img {
      height: 100%;
      width: 100%;
    }
  }
`



// WEBPACK FOOTER //
// ./src/styles/ColorPicker.js